/**
 * Formats a byte count as a human-readable size using binary units (KB = 1024 B).
 * Picks the largest unit where the value is >= 1 and renders with at most one
 * decimal place (no decimal for plain bytes).
 *
 * @util
 * @__NO_SIDE_EFFECTS__
 */
export function formatFileSize(bytes) {
    if (bytes == null || !Number.isFinite(bytes) || bytes < 0) {
        return null;
    }
    if (bytes < 1024) {
        return `${Math.round(bytes)} B`;
    }
    const units = ['KB', 'MB', 'GB', 'TB'];
    let value = bytes / 1024;
    let unitIndex = 0;
    while (value >= 1024 && unitIndex < units.length - 1) {
        value /= 1024;
        unitIndex += 1;
    }
    const rounded = value >= 10 ? Math.round(value) : Math.round(value * 10) / 10;
    return `${rounded} ${units[unitIndex]}`;
}
//# sourceMappingURL=formatFileSize.js.map